import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { AppProvider } from "./app-state";
import { ClipboardFeedback } from "./clipboard-feedback";
import "./styles.css";

const WalletApp = lazy(() => import("./features/wallet/WalletApp").then(module => ({ default: module.WalletApp })));
const isWallet = location.pathname === "/wallet" || location.pathname.startsWith("/wallet/");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      {isWallet ? <Suspense fallback={<main>Opening STC Wallet…</main>}><WalletApp /></Suspense> : <AppProvider>
        <App />
        <ClipboardFeedback />
      </AppProvider>}
    </BrowserRouter>
  </StrictMode>,
);
